import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import NewsletterCampaignTableRow from './NewsletterCampaignTableRow';

const COLUMN_LABELS = [
  { id: 'campaign', label: 'Campaign', align: 'left' },
  { id: 'sendDate', label: 'Send date', align: 'left' },
  { id: 'subject', label: 'Subject', align: 'left' },
  { id: 'audience', label: 'Audience', align: 'right' },
  { id: 'sent', label: 'Sent', align: 'right' },
  { id: 'delivered', label: 'Delivered', align: 'right' },
  { id: 'bounced', label: 'Bounced', align: 'right' },
  { id: 'uniqueClickers', label: 'Unique clickers', align: 'right' },
  { id: 'clicks', label: 'Clicks', align: 'right' },
  { id: 'unsubs', label: 'Unsubs', align: 'right' },
  { id: 'complaints', label: 'Complaints', align: 'right' },
  { id: 'failures', label: 'Failures', align: 'right' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'metrics', label: 'Metrics', align: 'left' },
];

function NewsletterCampaignsTableHead() {
  return (
    <TableHead>
      <TableRow>
        {COLUMN_LABELS.map((column) => (
          <TableCell key={column.id} align={column.align}>
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function NewsletterCampaignsTable({ campaigns }) {
  const rows =
    campaigns.length === 0 ? (
      <TableRow>
        <TableCell colSpan={COLUMN_LABELS.length}>
          <Typography variant="body2" color="text.secondary">
            No newsletter campaigns yet.
          </Typography>
        </TableCell>
      </TableRow>
    ) : (
      campaigns.map((campaign) => (
        <NewsletterCampaignTableRow key={campaign.id} campaign={campaign} />
      ))
    );

  return (
    <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto' }}>
      <Table size="small">
        <NewsletterCampaignsTableHead />
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
}

export default NewsletterCampaignsTable;
